import Konva from 'konva';
import { KonvaGroupNames } from 'components/tool/utils';
import { KONVA_OBS_GROUP } from '../../../../constants';
import { OBSTRUCTION_DEFAULT_FILL } from './utils';

const lineConfig = {
	stroke: 'red',
	strokeWidth: 2,
	dash: [6, 4],
	fill: OBSTRUCTION_DEFAULT_FILL,
	strokeScaleEnabled: false,
};

export function recreateKonvaFromObstruction(
	obstruction: Obstruction,
	obsDrawerGroup: Konva.Group,
	scaleX: number,
	scaleY: number
) {
	console.log('Recreating the obs....', obstruction, obsDrawerGroup);

	const group = new Konva.Group({
		id:
      obstruction.id +
      KONVA_OBS_GROUP.GROUP_NAME_SEPARATOR +
      KONVA_OBS_GROUP.IN_PROGRESS_GROUP_NAME,
		name: KonvaGroupNames.inProgressUserDefinedObsGroup,
		draggable: true,
	});

	if (obstruction.shapeType === 'CIRCLE') {
		const worldPts = obstruction.coordinates;

		// Convert back to screen space
		const screenPts = worldPts.map(([x, y]) => [
			x * scaleX,
			y * scaleY,
		]);

		// centroid
		let sumX = 0;
		let sumY = 0;
		screenPts.forEach(([x, y]) => {
			sumX += x;
			sumY += y;
		});

		const cx = sumX / screenPts.length;
		const cy = sumY / screenPts.length;

		// radius = average distance
		let sumR = 0;
		screenPts.forEach(([x, y]) => {
			const dx = x - cx;
			const dy = y - cy;
			sumR += Math.sqrt(dx * dx + dy * dy);
		});

		const radius = sumR / screenPts.length;

		const circle = new Konva.Circle({
			x: cx,
			y: cy,
			radius,
			...lineConfig,
			name: 'obs-circle',
			id:
        obstruction.id +
        KONVA_OBS_GROUP.GROUP_NAME_SEPARATOR +
        KONVA_OBS_GROUP.CIRCLE_ID_SUFFIX,
		});

		circle.setAttr('completed', true);
		group.add(circle);
	}

	else if (obstruction.shapeType === 'RECT') {
		const worldPts = obstruction.coordinates;

		const screenPts = worldPts.map(([x, y]) => [
			x * scaleX,
			y * scaleY,
		]);

		const xs = screenPts.map((p) => p[0]);
		const ys = screenPts.map((p) => p[1]);

		const minX = Math.min(...xs);
		const minY = Math.min(...ys);
		const maxX = Math.max(...xs);
		const maxY = Math.max(...ys);

		const rect = new Konva.Rect({
			x: minX,
			y: minY,
			width: maxX - minX,
			height: maxY - minY,
			...lineConfig,
			name: 'obs-rectangle',
			id:
        obstruction.id +
        KONVA_OBS_GROUP.GROUP_NAME_SEPARATOR +
        KONVA_OBS_GROUP.RECT_ID_SUFFIX,
		});

		rect.setAttr('completed', true);
		group.add(rect);
	}

	else {
		const screenPoints = obstruction.coordinates.flatMap(
			([x, y]) => [x * scaleX, y * scaleY]
		);

		const polygon = new Konva.Line({
			points: screenPoints,
			closed: true,
			...lineConfig,
			name: 'obs-line',
			id:
        obstruction.id +
        KONVA_OBS_GROUP.GROUP_NAME_SEPARATOR +
        KONVA_OBS_GROUP.LINE_ID_SUFFIX,
		});

		polygon.setAttr('closed', true);
		group.add(polygon);
	}

	obsDrawerGroup.add(group);
	obsDrawerGroup.getLayer()?.batchDraw();

	console.log('Group: ', group);
	console.log('obsDrawerGroup: ', obsDrawerGroup);
	return group;
}
